import { createContext, useContext } from "react";

export interface SelectionContextValue {
	selectedIds: Set<string>;
	setSelectedIds: (ids: Set<string>) => void;
	elementRefs: Map<string, HTMLElement>;
	payloads: Map<string, unknown>;
	cancelCurrentSelection: () => void;
}

export const SelectionContext = createContext<SelectionContextValue | null>(null);

export function useSelectionContext() {
	const ctx = useContext(SelectionContext);
	if (!ctx) throw new Error("Must be used within SelectionProvider");
	return ctx;
}

export function intersectsBox(
	box: { left: number; top: number; width: number; height: number },
	rect: DOMRect,
) {
	const left = rect.left + window.scrollX;
	const top = rect.top + window.scrollY;
	return (
		box.left < left + rect.width &&
		box.left + box.width > left &&
		box.top < top + rect.height &&
		box.top + box.height > top
	);
}
